import React from 'react';
import { faArrowDown, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { TimelineAllDayBar } from './TimelineAllDayBar';
import { TimelineScaleSelect } from './TimelineScaleSelect';
import { TimelineScale } from './types';
import { useTimelineView } from './TimelineViewContext';
import { dateFromLocalKey } from './dateUtils';
import { getPeriodDate, getPeriodLabel } from './timelineViewUtils';

export const TimelineControls = () => {
    const { t, i18n } = useTranslation();
    const {
        activeTimelineDateKey, activeTimelineLabel, onGoToNextTask, onOpenSchedule, onScaleChange, selectedDate,
        onShowCompletedTasksChange, showCompletedTasks, timelineScale, timelineZoomAnchorDate,
    } = useTimelineView();
    const parents: Partial<Record<TimelineScale, TimelineScale>> = {
        day: 'month', month: 'year', year: 'years',
    };
    const parent = parents[timelineScale];
    const activeDate = timelineZoomAnchorDate || (activeTimelineDateKey ? dateFromLocalKey(activeTimelineDateKey) : selectedDate);
    const label = getPeriodLabel(getPeriodDate(selectedDate, timelineScale, 0), timelineScale, i18n.language);
    return (
        <div className="timeline-zoom-controls">
            <div className="timeline-zoom-controls-main">
                <button type="button" className="timeline-active-period-label"
                    onClick={() => parent && onScaleChange(parent, activeDate)} disabled={!parent}
                    aria-label={parent ? t('dailyPlanner.zoomOut') : undefined}
                    title={parent ? t('dailyPlanner.zoomOut') : undefined}>
                    {activeTimelineLabel || label}
                </button>
                <TimelineScaleSelect value={timelineScale} onOpenSchedule={onOpenSchedule}
                    onScaleChange={(scale) => onScaleChange(scale, activeDate)} />
                <button type="button" className="timeline-completed-toggle"
                    onClick={() => onShowCompletedTasksChange(!showCompletedTasks)}
                    aria-pressed={showCompletedTasks}
                    aria-label={t('dailyPlanner.showCompletedTasks')}
                    title={t('dailyPlanner.showCompletedTasks')}>
                    <FontAwesomeIcon icon={showCompletedTasks ? faEye : faEyeSlash} />
                </button>
                <button type="button" className="timeline-next-task-button" onClick={onGoToNextTask}
                    aria-label={t('dailyPlanner.nextTask')} title={t('dailyPlanner.nextTask')}>
                    <FontAwesomeIcon icon={faArrowDown} />
                </button>
            </div>
            <TimelineAllDayBar />
        </div>
    );
};
